import {
    BoldPlugin,
    ItalicPlugin,
    UnderlinePlugin,
    StrikethroughPlugin,
    HeadingPlugin,
    BlockquotePlugin,
} from '@platejs/basic-nodes/react';
import {
    TablePlugin,
    TableRowPlugin,
    TableCellPlugin,
    TableCellHeaderPlugin,
} from '@platejs/table/react';
import { IndentPlugin } from '@platejs/indent/react';
import { ListPlugin } from '@platejs/list/react';
import { LinkPlugin } from '@platejs/link/react';
import {
    TableElement,
    TableRowElement,
    TableCellElement,
    TableCellHeaderElement,
} from '../ui/table-node';

const LIST_INDENT_TARGETS = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'];

export const BasicMarksPlugins = [
    BoldPlugin,
    ItalicPlugin,
    UnderlinePlugin,
    StrikethroughPlugin,
];

export const BasicBlocksPlugins = [
    HeadingPlugin,
    BlockquotePlugin,
];

export const TablePlugins = [
    TablePlugin.withComponent(TableElement),
    TableRowPlugin.withComponent(TableRowElement),
    TableCellPlugin.withComponent(TableCellElement),
    TableCellHeaderPlugin.withComponent(TableCellHeaderElement),
];

export const editorPlugins = [
    ...BasicMarksPlugins,
    ...BasicBlocksPlugins,
    ...TablePlugins,

    IndentPlugin.configure({
        inject: { targetPlugins: LIST_INDENT_TARGETS },
    }),
    ListPlugin.configure({
        inject: { targetPlugins: LIST_INDENT_TARGETS },
    }),

    LinkPlugin,
];
